/**
 * Product Card Swatch Image Swap
 * Swaps the primary product card image when a color swatch is hovered or clicked.
 */
(function () {
  function handleSwatchInteraction(swatch) {
    var card = swatch.closest('.product-card');
    if (!card) return;

    var imageSrc = swatch.dataset.variantImage;
    var imageSrcset = swatch.dataset.variantSrcset;
    var variantUrl = swatch.dataset.variantUrl;
    var variantPrice = swatch.dataset.variantPrice;
    var variantComparePrice = swatch.dataset.variantComparePrice;

    // Update active state
    var group = swatch.closest('[data-swatch-group]');
    if (group) {
      group.querySelectorAll('.product-card__swatch').forEach(function (s) {
        s.classList.remove('is-active');
      });
    }
    swatch.classList.add('is-active');

    // Swap primary image and suppress secondary-image hover
    if (imageSrc) {
      var mediaWrapper = card.querySelector('.product-card__media');
      var primaryImage = card.querySelector('.product-card__primary-image');
      if (primaryImage) {
        primaryImage.src = imageSrc;
        if (imageSrcset) {
          primaryImage.srcset = imageSrcset;
        }
      }
      if (mediaWrapper) {
        mediaWrapper.classList.add('swatch-swapped');
      }
    }

    // Update product link to point to the variant
    if (variantUrl) {
      var links = card.querySelectorAll('a[href]');
      links.forEach(function (link) {
        link.href = variantUrl;
      });
    }

    // Update price display
    if (variantPrice) {
      var priceContainer = card.querySelector('.product-card__price');
      if (priceContainer) {
        if (variantComparePrice) {
          priceContainer.innerHTML =
            '<span class="price__sale">' + variantPrice + '</span>' +
            '<span class="price__compare">' + variantComparePrice + '</span>';
        } else {
          priceContainer.innerHTML =
            '<span class="price__regular">' + variantPrice + '</span>';
        }
      }
    }
  }

  function init() {
    document.addEventListener('pointerover', function (e) {
      var swatch = e.target.closest('.product-card__swatch');
      if (swatch) handleSwatchInteraction(swatch);
    });

    document.addEventListener('click', function (e) {
      var swatch = e.target.closest('.product-card__swatch');
      if (swatch) {
        e.preventDefault();
        handleSwatchInteraction(swatch);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
